var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"searchSingleItemFocusImage",on:{"click":_vm.closeImage}},[_c('img',{attrs:{"src":_vm.image},on:{"click":function($event){$event.stopPropagation();}}}),_c('button',{on:{"click":_vm.closeImage}},[_vm._v(" ✕ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }